import { createSignal, Show, JSX } from "solid-js";

interface DropdownMenuProps {
  label: string;
  children: JSX.Element;
  class?: string;
}

export function DropdownMenu(props: DropdownMenuProps) {
  const [open, setOpen] = createSignal(false);
  const [pos, setPos] = createSignal({ top: 0, right: 0 });
  let triggerRef!: HTMLButtonElement;

  const toggle = () => {
    if (!open()) {
      const r = triggerRef.getBoundingClientRect();
      setPos({ top: r.bottom + 4, right: window.innerWidth - r.right });
    }
    setOpen(!open());
  };

  return (
    <div class="inline-block">
      <button
        ref={triggerRef}
        onClick={toggle}
        class={`text-xs px-2 py-1 bg-gray-800 text-gray-300 rounded hover:bg-gray-700 cursor-pointer ${props.class ?? ""}`}>
        {props.label}
      </button>
      <Show when={open()}>
        <div class="fixed inset-0 z-40" onClick={() => setOpen(false)} />
        <div
          class="fixed z-50 w-44 bg-gray-800 border border-gray-700 rounded-lg shadow-xl py-1"
          style={{ top: `${pos().top}px`, right: `${pos().right}px` }}
          onClick={() => setOpen(false)}>
          {props.children}
        </div>
      </Show>
    </div>
  );
}
